import styled from '@emotion/styled';
import { useNavigate } from 'react-router-dom';
import {
  selectExamsSearchPrerequisites,
  selectShowAvailableExams,
  setShowAvailableExams,
} from 'store/exams-search/examsSearchSlice';
import { useAppDispatch, useAppSelector } from 'store';
import { useLazySearchExamsQuery } from 'store/exams-search/examsSearchAPI';
import { selectBasketExams } from 'store/basket/basketSlice';
import { ROUTES } from 'core';

import { ApiErrorPage, Divider } from '@britishcouncil/react-solas-ors3';
import { Alert, Button } from '@britishcouncil/react-solas';

import { ExamCard } from './ExamCard';

export const ExamsList = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const searchPrerequisites = useAppSelector(selectExamsSearchPrerequisites);
  const showAvailableExams = useAppSelector(selectShowAvailableExams);
  const examsInBasket = useAppSelector(selectBasketExams);

  const [triggerSearchQuery, { data, error, isFetching }] = useLazySearchExamsQuery();

  const redirectToBasket = () => {
    navigate(ROUTES.BASKET);
  };

  if (!searchPrerequisites.complete && !showAvailableExams) return null;

  if (searchPrerequisites.complete && !showAvailableExams)
    return (
      <Button loading={isFetching} onClick={handleSearchClick}>
        Search
      </Button>
    );

  return (
    <>
      {searchPrerequisites.complete && (
        <Button loading={isFetching} onClick={handleSearchClick}>
          Search
        </Button>
      )}
      <Divider />

      {examsInBasket.length > 0 && (
        <StyledButton type="button" intent="success" onClick={redirectToBasket}>
          Go to basket
        </StyledButton>
      )}

      {error && <ApiErrorPage />}
      {!error && data && data.length === 0 && <Alert type="warning">No exams found</Alert>}
      {!error && data && data.length > 0 && data.map((exam) => <ExamCard key={exam.id} exam={exam} />)}
    </>
  );

  function handleSearchClick() {
    triggerSearchQuery(searchPrerequisites);
    dispatch(setShowAvailableExams());
  }
};

const StyledButton = styled(Button)`
  margin-bottom: 1em;
`;
